import React, { useState } from "react";
import ReactInputMask from "react-input-mask";
import {
  Button,
  Col,
  Input,
  InputGroup,
  Row,
  InputGroupText,
  FormGroup,
  Label,
} from "reactstrap";
import Calendar from "assets/icon/calendar-pms.svg";
import addIcon from "../../../../../assets/icon/add.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import Checkbox from "components/common/Fields/Checkbox";
import closeIcon from "../../../../../assets/icon/close.svg";
import addBlackIcon from "../../../../../assets/icon/add-black-icon.svg";
import Select from "react-select";
import { Field, Formik } from "formik";
import calenderBlackIcon from "../../../../../assets/inventory/calender-black-icon.svg";

const PatientEditInfo = () => {
  const [data, setData] = useState({
    prefix: [
      { value1: "Dr", label1: "Dr" },
      { value2: "Med Dr", label2: "Med Dr" },
    ],
    maidenName: "Ramirez",
    ssn: "123456455",
    maritalStatus: "Married",
    firstname: "John",
    middlename: "",
    lastname: "Doe",
    dob: "",
    gender: "",
    streetaddres1: "101 Main St",
    streetaddres2: "",
    city: "Spring Field",
    state: "Il",
    // zipcode: "",
    country: "USA",
    primaryPhone: "(123)-456-7890",
    secondaryPhone: "(987)-654-3210",
    email: "john@gmail.com",
    primaryPrescriber: "",
    preferredlanguage: "",
    requiredTranslation: "",
    childsafetycaps: "",
    hippaAcknowledge: "",
    hippaAcknowledgeDate: "",
  });

  const [startDate, setStartdate] = useState(new Date());
  const [hippaStartDate, setHippaStartDate] = useState(new Date());
  const [hippaFocusInput, setHippaFocusInput] = useState("");
  const [focusedInput, setFocusedInput] = useState("");
  const [allergies, setAllergies] = useState([{ id: 1, data: "Penicillin" },{ id: 2, data: "Sulfa" }]);
  const [selectedOptions, setSelectedOptions] = useState([
    {
      male: "",
      female: "",
      city: "",
      state: "",
      country: "",
      language: "",
      translations: "",
      childsafety: "",
      hippa: "",
      pet: "",
      data: "",
    },
  ]);

  const handleSubmit = () => {
    if (selectedOptions.data) {
      setAllergies((prev) => [
        ...prev,
        { id: Date.now(), data: selectedOptions.data },
      ]);
    }
    setSelectedOptions((prev) => ({ ...prev, data: "" }));
  };

  const handleDelete = (id) => {
    setAllergies((prev) => prev.filter((item) => item.id !== id));
  };

  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "primaryPhone" || name === "secondaryPhone") {
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 3) {
        formattedValue = digits;
      } else if (digits.length <= 6) {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6, 10)}`;
      }
    } else {
      formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
    }
    setData({ ...data, [name]: formattedValue });
  };

  let hasDatePopupOpen = false;

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  let hasHippaDatePopupOpen = false;

  const handleHippaMouseLeave = () => {
    hasHippaDatePopupOpen = false;
  };

  const handleHippaStartDate = (hippaStartDate) => {
    if (hippaStartDate !== null) {
      const date = moment(hippaStartDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setHippaStartDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setHippaStartDate(null);
      // SearchTerms.startDate=null
    }
  };

  const handleHippaFocus = (inputName) => {
    setHippaFocusInput(inputName);
  };

  const handleHippaBlur = () => {
    setHippaFocusInput("");
  };

  const handleHippaStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && hippaStartDate !== null) {
      setHippaStartDate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleHippaStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleHippaDateClick = (id) => {
    if (hasHippaDatePopupOpen) {
      hasHippaDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasHippaDatePopupOpen = true;
    }
  };

  const GenderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "Unknown", label: "Unknown" },
  ];

  const prefixOption = [
    {
      value: "Dr",
      label: "Dr",
    },
    {
      value: "Med Dr",
      label: "Med Dr",
    },
  ];

  const suffixOption = [
    {
      value: "MD",
      label: "MD",
    },
    {
      value: "PhD",
      label: "PhD",
    },
  ];
  const handleOptionsChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta; // gets the name from Select
    const value = selectedOption?.value || "";
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <>
      <div className="invOrderDetails">
        <Formik>
          <FormGroup>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span>Last Name
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter First Name"
                      name="firstname"
                      value={data.firstname}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span>First Name
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Last Name"
                      name="lastname"
                      value={data.lastname}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Middle Initial/Name</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Middle Name"
                      name="middlename"
                      value={data.middlename}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">
                    <span className="text-danger me-1">*</span>Date of Birth
                  </div>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <DatePicker
                      id="startDate"
                      name="startDate"
                      selected={startDate}
                      onChange={(startDate) => handleStartDate(startDate)}
                      onFocus={() => handleFocus("StartDate")}
                      onBlur={handleBlur}
                      isClearable
                      onChangeRaw={handleStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask mask="99/99/9999" value={startDate} />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleDateClick("startDate")}
                    >
                      <img
                        src={focusedInput ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">Name Prefix</div>

                <Select
                  // isMulti
                  className="dropdown-options"
                  name="prefix"
                  value={data.prefix.value1}
                  options={prefixOption}
                  placeholder="Select Prefix"
                  onChange={(selectedOptions) => {
                    setData((prev) => ({
                      ...prev,
                      prefix: selectedOptions || [],
                    }));
                  }}
                />
              </Col>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">Name Suffix</div>

                <Select
                  className="dropdown-options"
                  name="suffix"
                  value={prefixOption.find(
                    (option) => option.value === data.suffix
                  )}
                  options={suffixOption}
                  placeholder="Select suffix"
                  onChange={handleOptionsChange}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span>Sex
                </div>
                {/* <InputGroup className="p-1">
                  <Field
                    as="select"
                    name="male"
                    id="option"
                    className="order-detail-input"
                    value={selectedOptions.male}
                    onChange={handleChangeOption}
                  >
                    <option value="male" label="Male" />
                    <option value="female" label="Female" />
                  </Field>
                </InputGroup> */}
                <Select
                  className="dropdown-options"
                  name="gender"
                  value={GenderOptions.find(
                    (option) => option.value === data.gender
                  )}
                  options={GenderOptions}
                  placeholder="Select Sex"
                  onChange={handleOptionsChange}
                />
              </Col>
            </Row>
            <div className="section-devider-border mt-3 mb-3"></div>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Address Line 1 </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Address 1"
                      name="streetaddres1"
                      value={data.streetaddres1}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Address Line 2</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Addess 2"
                      name="streetaddres2"
                      value={data.streetaddres2}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">City </div>{" "}
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "chicago", label: "Chicago" },
                    { value: "springfield", label: "Spring Field" },
                    { value: "rockford", label: "Rock Ford" },
                  ]}
                  placeholder="Select City"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">State/Province</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "newjercy", label: "New Jercy" },
                    { value: "Illinois", label: "Illinois" },
                    { value: "oklahoma", label: "Oklahoma" },
                  ]}
                  placeholder="Select State"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Zip/Postal Code </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "usa", label: "USA" },
                    { value: "india", label: "Inida" },
                    { value: "canada", label: "Canada" },
                  ]}
                  placeholder="Select Language"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">
                  {" "}
                  <span className="text-danger me-1">*</span>Primary Phone
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="(555)-123 1234"
                      name="primaryPhone"
                      value={data.primaryPhone}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Secondary Phone </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="(123)-456-7890"
                      name="secondaryPhone"
                      value={data.secondaryPhone}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">  <span className="text-danger me-1">*</span>Email</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Lorume@gmail.com"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <div className="section-devider-border mt-3 mb-3"></div>

            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Automatic Refills</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ]}
                  placeholder="Select"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Primary Prescriber</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Smith", label: "Smith" },
                    { value: "John", label: "Doe" },
                  ]}
                  placeholder="Select Prescriber"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Preferred Language</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "english", label: "English" },
                    { value: "hindi", label: "Hindi" },
                    { value: "french", label: "French" },
                  ]}
                  placeholder="Select Language"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Requires Translation </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select Translations"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Child Safety Caps</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select Safety Caps"
                />
              </Col>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">
                    HIPAA Acknowledgement Date
                  </div>
                  <InputGroup onMouseLeave={handleHippaMouseLeave}>
                    <DatePicker
                      id="hippaStartDate"
                      name="hippaStartDate"
                      selected={hippaStartDate}
                      onChange={(hippaStartDate) =>
                        handleHippaStartDate(hippaStartDate)
                      }
                      onFocus={() => handleHippaFocus("hippaStartDate")}
                      onBlur={handleHippaBlur}
                      isClearable
                      onChangeRaw={handleHippaStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask
                          mask="99/99/9999"
                          value={hippaStartDate}
                        />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleHippaDateClick("hippaStartDate")}
                    >
                      <img
                        src={hippaFocusInput ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">
                  HIPAA Acknowledgement{" "}
                </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select Acknowledgement"
                />
              </Col>
              <Col md="6"></Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="add-patient-heading mb">Notes</div>
                <div>
                  <FormGroup className="mb-0">
                    <Input
                      style={{ border: "1px soild" }}
                      className="textlength"
                      type="textarea"
                      placeholder="Enter Notes"
                    />
                  </FormGroup>
                </div>
              </Col>
            </Row>

            <div
              className="section-devider-border mt-3 mb-3"
              style={{ marginTop: "12px" }}
            ></div>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">County</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Travis", label: "Travis" },
                    { value: "Baldwin", label: "Baldwin" },
                    { value: "Blount", label: "Blount" },
                  ]}
                  placeholder="Select County"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Country </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select Country"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">SSN </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="(555)-123 1234"
                      name="ssn"
                      value={data.ssn}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Marital Status</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="(555)-123 1234"
                      name="maritalStatus"
                      value={data.maritalStatus}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Mother’s Maiden Name </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder=""
                      name="maidenName"
                      value={data.maidenName}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Deceased</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select "
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Race</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Travis", label: "Travis" },
                    { value: "Baldwin", label: "Baldwin" },
                    { value: "Blount", label: "Blount" },
                  ]}
                  placeholder="Select County"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Ethnicity</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select "
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">Deceased Date</div>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <DatePicker
                      id="startDate"
                      name="startDate"
                      selected={startDate}
                      onChange={(startDate) => handleStartDate(startDate)}
                      onFocus={() => handleFocus("StartDate")}
                      onBlur={handleBlur}
                      isClearable
                      onChangeRaw={handleStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask mask="99/99/9999" value={startDate} />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleDateClick("startDate")}
                    >
                      <img
                        src={focusedInput ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Residence Code</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "01-home", label: "01-Home" },
                    { value: "02-home", label: "02-Home" },
                  ]}
                  placeholder="Select Code"
                />
              </Col>
            </Row>
            <div
              className="section-devider-border mt-3 mb-3"
              style={{ marginTop: "12px!important" }}
            ></div>

            <Row>
              <Col md="12">
                <div className="add-patient-text">Allergies </div>
                <div className="veterinary-patient p-2 m-0">
                  <InputGroup className="bg-white">
                    <Input
                      placeholder="Add New Allergy"
                      name="data"
                      value={selectedOptions.data}
                      onChange={handleChangeOption}
                    />
                    {selectedOptions.data ? (
                      <img
                        src={addIcon}
                        alt=""
                        className="m-1 cursor-pointer"
                        onClick={handleSubmit}
                      />
                    ) : (
                      <img
                        src={addBlackIcon}
                        alt=""
                        className="m-1 cursor-pointer"
                        onClick={handleSubmit}
                      />
                    )}
                  </InputGroup>
                 
                  <div className="d-flex justify-content-start align-items-center direction-row gap-2">
                    {allergies.map((name) => (
                      <div
                        className={name.data ? "allergies-add-data" : ""}
                        key={name.id}
                      >
                        <div onClick={() => handleDelete(name.id)}>
                          <span>{name.data}</span>
                          <img
                            src={name.data ?closeIcon : ""}
                            alt=""
                            className="cursor-pointer"
                          />
                        </div>
                        
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="section-devider-border mt-3 mb-3"></div>
            <div className="add-patient-text d-flex justify-content-between align-items-center mt-2">
              <div>Veterinary Patient</div>
              <Checkbox activeCheck={true} />
            </div>
            <Row className="veterinary-patient p-2 m-0 gap-2">
              <Col className="p-0">
                <div className="add-patient-species mt-0">Species </div>
                <Select
                  className="dropdown-options add-patient-pr ms-1"
                  options={[
                    { value: "dog", label: "Dog" },
                    { value: "cat", label: "Cat" },
                    { value: "horse", label: "Horse" },
                  ]}
                  placeholder="Select Species"
                />
              </Col>
              <Col className="p-0">
                <div className="add-patient-species mt-0 ms-0">Owners Name</div>
                <div>
                  <InputGroup className="p-0">
                    <Input
                      placeholder="Enter Owner Name"
                      name="ownername"
                      value={data.ownername}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              {/* </Row> */}
            </Row>
          </FormGroup>
        </Formik>
      </div>
    </>
  );
};

export default PatientEditInfo;
